import { /* ErrorMessage, */ Field, Form, Formik } from 'formik';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Alert,
} from 'reactstrap';
import axios from 'utils/axios';
import * as Yup from 'yup';
import { createUseStyles } from 'react-jss';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { startsWith } from 'lodash-es';
import AntButton from 'antd/lib/button';
import 'antd/lib/button/style/index.css';
import SignupVerifyOtpModal from './SignUpVerifyOtpModal';

const SignupSchema = Yup.object().shape({
  username: Yup.string(),
  password: Yup.string().required('Required'),
  confirmPassword: Yup.string().required('Required'),
});

/* ----------------Styles-------------- */
const useStyles = createUseStyles({
  signInButton: {
    width: '100%',
    backgroundColor: '#2675b8',
    color: 'white',
    '&:hover': {
      backgroundColor: '#2675b8',
      color: 'white',
    },
    border: 'none',
  },
  forgotPassword: {
    '&:hover': {
      textDecoration: 'underline',
      color: '#b4b5be',
    },
    paddingLeft: '3px',
    color: '#b4b5be',
  },
  createAccount: {
    '&:hover': {
      textDecoration: 'underline',
      color: '#b4b5be',
    },
    paddingRight: '3px',
    color: '#b4b5be',
  },
  phoneInput: {
    backgroundColor: 'black',
  },
  signinButton: {
    marginTop: '4px',
    height: '43px',
    backgroundColor: '#2675b8',
    width: '100%',
    color: 'white',
    border: 'none',
    '&:hover': {
      backgroundColor: '#2675b8!important',
      color: 'white!important',
    },
    '&:focus': {
      backgroundColor: '#2675b8!important',
      color: 'white!important',
    },
    borderRadius: '5px',
  },
});

const Signup = () => {
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const classes = useStyles();

  const [verifyOTPModalOpen, setVerifyOTPModalOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');

  const toggleVerifyOTPModalOpen = () =>
    setVerifyOTPModalOpen(!verifyOTPModalOpen);

  const handleSubmit = async (
    { username, password, confirmPassword },
    { setSubmitting },
  ) => {
    try {
      setError('');
      const formattedUsername = startsWith('+', username)
        ? username
        : `+${username}`;
      const { data } = await axios.post('/users/signUp', {
        phone: formattedUsername,
        password,
        confirmPassword,
      });
      console.log(data);
      setPhoneNumber(formattedUsername);
      toggleVerifyOTPModalOpen();
    } catch (error) {
      if (error.response?.data) {
        setError(error.response?.data);
      } else {
        setError('Signup failed');
      }
      console.log(error.response);
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '445px',
          alignItems: 'center',
        }}
      >
        <Card
          className="bg-secondary shadow border-0"
          style={{ width: '100%' }}
        >
          <CardHeader className="">
            <div to="/" tag={Link} className="text-muted text-center mt-2 mb-3">
              <img
                alt="..."
                src={require('../../assets/companyLogo/jplogo.png').default}
                style={{ width: '200px' }}
              />
            </div>
          </CardHeader>
          <CardBody className="px-lg-5 py-lg-5">
            {error ? (
              <div className="text-center text-muted mb-4">
                <Alert className="m-3" variant="danger">
                  {error}
                </Alert>
              </div>
            ) : null}

            <Formik
              initialValues={{
                username: '',
                password: '',
                confirmPassword: '',
              }}
              onSubmit={handleSubmit}
              validationSchema={SignupSchema}
            >
              {({ values, isSubmitting, setFieldValue }) => (
                <Form>
                  <FormGroup className="mb-3">
                    <PhoneInput
                      name="username"
                      country={'in'}
                      placeholder="Phone Number with country code"
                      value={values.username}
                      onChange={(phone) => setFieldValue('username', phone)}
                      inputStyle={{ width: '100%', height: '43px' }}
                      countryCodeEditable={false}
                      enableSearch={true}
                    />
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <InputGroup
                      className="input-group-alternative"
                      style={{
                        boxShadow: 'none',
                        border: '0.5px solid #cfcfcf',
                        borderRadius: '3px',
                      }}
                    >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="ni ni-lock-circle-open" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Field
                        name="password"
                        type={showPassword ? 'text' : 'password'}
                        className="form-control"
                        placeholder="Password"
                        disabled={isSubmitting}
                      />
                      <InputGroupAddon addonType="append">
                        <InputGroupText>
                          <i
                            className={`fa ${
                              showPassword ? 'fa-eye-slash' : 'fa-eye'
                            }`}
                            onClick={() => setShowPassword(!showPassword)}
                            style={{ cursor: 'pointer' }}
                          />
                        </InputGroupText>
                      </InputGroupAddon>
                      {/* <ErrorMessage
                        name="password"
                        component="small"
                        className="form-text text-danger"
                      /> */}
                    </InputGroup>
                  </FormGroup>

                  <FormGroup>
                    <InputGroup
                      className="input-group-alternative"
                      style={{
                        boxShadow: 'none',
                        border: '0.5px solid #cfcfcf',
                        borderRadius: '3px',
                      }}
                    >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="ni ni-lock-circle-open" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Field
                        name="confirmPassword"
                        type={showConfirmPassword ? 'text' : 'password'}
                        className="form-control"
                        placeholder="Confirm Password"
                        disabled={isSubmitting}
                      />
                      <InputGroupAddon addonType="append">
                        <InputGroupText>
                          <i
                            className={`fa ${
                              showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'
                            }`}
                            onClick={() =>
                              setShowConfirmPassword(!showConfirmPassword)
                            }
                            style={{ cursor: 'pointer' }}
                          />
                        </InputGroupText>
                      </InputGroupAddon>
                      {/* <ErrorMessage
                        name="password"
                        component="small"
                        className="form-text text-danger"
                      /> */}
                    </InputGroup>
                  </FormGroup>

                  <div className="text-center">
                    <AntButton
                      className={classes.signinButton}
                      loading={isSubmitting}
                      htmlType="submit"
                    >
                      Create Account
                    </AntButton>
                  </div>
                </Form>
              )}
            </Formik>
          </CardBody>
        </Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '445px',
            marginTop: '15px',
          }}
        >
          <Link className={classes.createAccount} to={`/auth/forgotPassword`}>
            <small>Forgot password?</small>
          </Link>

          <Link className={classes.createAccount} to="/auth/login">
            <small>Login instead?</small>
          </Link>
        </div>
      </div>

      <SignupVerifyOtpModal
        toggleVerifyOTPModalOpen={toggleVerifyOTPModalOpen}
        verifyOTPModalOpen={verifyOTPModalOpen}
        username={phoneNumber}
      />
    </>
  );
};

export default Signup;
